import { createAction } from 'app-components/flux/core/actionHelpers';

export const getInvestmentTWRR = createAction(
  'GET_INVESTMENT_TWRR',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getInvestmentTWRRSuccess = createAction('GET_INVESTMENT_TWRR_SUCCESS');
export const getInvestmentTWRRFailure = createAction('GET_INVESTMENT_TWRR_FAILURE');
